import React from "react";
import { Row, Col } from "react-bootstrap";
import style from "./pastor.module.css";
import { LuDownload } from "react-icons/lu";

const PastorLaunchKit = () => {
const launchItems = [
  {
    icon: "/Icon.png",
    title: "Pulpit announcement",
  },
  {
    icon: "/Icon (1).png",
    title: "Sample email",
  },
  {
     icon: "/Icon (2).png",
    title: "Sample text message",
  },
  {
     icon: "/Icon (3).png",
    title: "Social media post",
  },
  {
   icon: "/Icon (4).png",
    title: "QR code template",
  },
  {
     icon: "/Icon (5).png",
    title: "21-day campaign calendar",
  },
];

  return (
    <>
      <div className="container">
        <h1 className={style.mainheadingpastorlaunch}>
          Pastors are Seeing the Impact
        </h1>
      </div>

      <div className={style.mainlaunchpartordiv}>
        <div className="container">
          <div className={style.mainlaunchpastor}>
            <h1>Pastor Launch Kit</h1>

            <div className={style.launchpastorbutton}>
              <button>Download the Pastor Launch Kit <img src="/downloadicon.png" className={style.downloadIcon} /></button>
              

            </div>
      </div>
            <div className={style.launchKitGrid}>
              <Row>
                {launchItems.map((item, index) => (
                  <Col md={4} sm={6} xs={12} key={index}>
                    <div className={style.launchCard}>
                      <div className={style.iconBox}>
                     <img src={item.icon} alt={item.title} />
                      </div>
                      <h4>{item.title}</h4>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </div>
        </div>
    
    </>
  );
};

export default PastorLaunchKit;